import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { BonusSection } from './components/BonusSection';
import { ValueSummary } from './components/ValueSummary';
import { OrderBumpsSection } from './components/OrderBumpsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeAndFinalCTA } from './components/GuaranteeAndFinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
import { OrderProvider } from './lib/orderContext';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <OrderProvider data-id="element-0">
      <div className="min-h-screen bg-[#faf6ee] font-sans text-[#2d2d2d]" data-id="element-1">
        <Hero data-id="element-2" />
        <BonusSection data-id="element-3" />
        <ValueSummary data-id="element-4" />
        <OrderBumpsSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <GuaranteeAndFinalCTA data-id="element-8" />
        <Footer data-id="element-9" />
      </div>
    </OrderProvider>;
}